import { useResource } from '@thesisedu/feature-react'
import { orderBy } from 'lodash'

import { BadgeEventTypeResource } from './types'

export function useBadgeEventTypes() {
  const resources = useResource<BadgeEventTypeResource<any>>('BadgeEventType')
  return orderBy(resources, 'displayWeight', 'asc')
}
